/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens.
 * Enables TAB key navigation support for dropdown menus.
 * Moves Utility menu in DOM for mobile/desktop
 */
( function() {
	const siteBanner = document.querySelector('.site-header'),
		  siteNavigation = document.getElementById( 'site-navigation' ),
	  	  utilityEl = document.getElementById('utility'),
	  	  primaryMenuEl = document.getElementById('primary-menu'),
		  eyebrowNavigation = document.querySelector( '.eyebrow-nav-block' ),
		  eyebrowContent = !!eyebrowNavigation ? eyebrowNavigation.querySelector( '.block__content' ) : false,
		  eyebrowMenu = !!eyebrowNavigation ? eyebrowNavigation.querySelector( '.eyebrow-nav-block__menu' ) : false,
		  siteBrandingEl = document.getElementById('site-branding'),
		  utilitySection = document.getElementById('utility-section'),
		  searchForm = document.querySelector('.search-form'),
		  menuItemsWithChildren = document.querySelectorAll('li.depth-0.menu-item-has-children');

	const utilityLastChild = utilityEl !== null ? Array.from( utilityEl.querySelectorAll('.menu-item') ).pop() : [];

	// Return early if the navigation doesn't exist.
	if ( ! siteNavigation ) {
		return;
	}

	const toggleMobileBtn = siteNavigation.getElementsByTagName( 'button' )[ 0 ];

	// Return early if the button don't exist.
	if ( 'undefined' === typeof toggleMobileBtn ) {
		return;
	}

	const menu = siteNavigation.getElementsByTagName( 'ul' )[ 0 ];

	// Hide menu toggle button if menu is empty and return early.
	if ( 'undefined' === typeof menu ) {
		toggleMobileBtn.style.display = 'none';
		return;
	}

	// SITE NAVIGATION - Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	toggleMobileBtn.addEventListener( 'click', function() {
		siteNavigation.classList.toggle( 'toggled' );

		if ( toggleMobileBtn.getAttribute( 'aria-expanded' ) === 'true' ) {
			toggleMobileBtn.setAttribute( 'aria-expanded', 'false' );
			document.body.style.overflow = 'scroll';
		} else {
			toggleMobileBtn.setAttribute( 'aria-expanded', 'true' );
			document.body.style.overflow = 'hidden';
		}
	} );

	// Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
	document.addEventListener( 'click', function( event ) {
		const isClickInside = siteNavigation.contains( event.target );

		if ( ! isClickInside ) {
			siteNavigation.classList.remove( 'toggled' );
			toggleMobileBtn.setAttribute( 'aria-expanded', 'false' );
		}
	} );

	const resetTopLevelDropdowns = (type) => {
		let toplevelMenuItemsOpen = document.querySelectorAll('li.depth-0.open');
		
		if ( type == 'mouse' && toplevelMenuItemsOpen ) {
			document.activeElement.blur();
			
			// close any that are open
			toplevelMenuItemsOpen.forEach(function (el) {
				el.querySelector('a').setAttribute('aria-expanded', 'false');
				el.querySelector('button').setAttribute('aria-expanded', 'false');
				el.classList.remove('open');
			});
		}
	}

	// top level menu items that have children
	menuItemsWithChildren.forEach(function (el) {
		el.querySelector('button.js-toggle-dropdown').addEventListener('click',  function(event){
			event.preventDefault();
			const menuItem = this.parentNode.parentNode,
					menuItemAnchor = menuItem.querySelector('a'),
					menuItemBtn = menuItem.querySelector('button');

			// keyboard only or viewport <1200px
			const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
			if ( whatInput.ask() === 'keyboard' || vw < 1200) {
				
				// open the menu on click/enter key for keyboard users
				if (!menuItem.classList.contains('open')) {

					menuItem.classList.add('open');
					menuItemAnchor.setAttribute('aria-expanded', 'true');
					menuItemBtn.setAttribute('aria-expanded', 'true');

					// set focusout to close when tabbing out of dropdown
					menuItem.addEventListener('focusout', function(event) {
						if (this.contains(event.relatedTarget)) {
							return;
						}

						// if still using keyboard reset dropdown
						if (whatInput.ask('intent') === 'keyboard') {
							this.querySelector('a').setAttribute('aria-expanded', 'false');
							this.querySelector('button').setAttribute('aria-expanded', 'false');
							this.classList.remove('open');
						}
					});

				} else {
					menuItem.classList.remove('open');
					menuItemAnchor.setAttribute('aria-expanded', 'false');
					menuItemBtn.setAttribute('aria-expanded', 'false');
				}
			}
		});
	});
	
	/**
	 * Creates mobile menu container and moves primary menu into it.
	 */
	const mobilePrimaryMenu = () => {
		const searchMenuItem = document.querySelector('.primary-menu .menu-item-search'),
		      searchFormEl = document.querySelector('.search-form');

        searchMenuItem.appendChild(searchFormEl);

		let mobileMenuContainer = document.createElement('div');

		mobileMenuContainer.setAttribute('id', 'mobile-menu-container');
		mobileMenuContainer.setAttribute('class', 'mobile-menu-container');

		let mobileMenuEl = primaryMenuEl.cloneNode(true);

		const mobileMenuHasChildren = mobileMenuEl.querySelectorAll('.depth-0.menu-item-has-children');
		if(typeof mobileMenuHasChildren === "object" && mobileMenuHasChildren.length) {
			[].forEach.call(mobileMenuHasChildren, menuItem => {

				// Add parent menu item to child menu
				if(!menuItem.classList.contains('is-label') && menuItem.hasChildNodes()) {
					const subMenu  = menuItem.querySelector('.sub-menu');
					const link     = menuItem.querySelector(':scope > a');
					const isColumn = !!subMenu ? !!subMenu.querySelector('.is-label') : false;

					let li = document.createElement('li');
					let dupLink = link.cloneNode(true);
					let dupLinkButton = dupLink.querySelector('.js-toggle-dropdown');

					if(!!dupLinkButton) {
						dupLink.removeChild(dupLinkButton);
					}
					li.appendChild(dupLink);

					menuItem.classList.forEach(clss => {
						switch(clss) {
							case 'depth-0':
								li.classList.add('depth-2');
								break;
							case 'mega-menu':
								break;
							case 'current-menu-item':
								break;
							case 'menu-item-has-children':
								break;
							case 'current_page_ancestor':
								break;
							case 'current-menu-ancestor':
								break;
							default:
								li.classList.add(clss);
						}
					});

					li.classList.add('is-bold');

					if(isColumn) {
						const columnSubMenu = subMenu.querySelector('.sub-menu');

						if(!!columnSubMenu) {
							columnSubMenu.insertBefore(li, columnSubMenu.firstChild);
						}
					} else {
						if (typeof columnSubMenu === 'defined') {
							subMenu.insertBefore(li, columnSubMenu.firstChild);
						}
					}
				}

				// Disable the parent link
				menuItem.addEventListener('click', event => {
					const link = menuItem.querySelector(':scope > a');

					if((!!link && event.target === link)
						|| event.target.classList.contains('js-toggle-dropdown')
						|| event.target.classList.contains('fa-angle-down')
						|| event.target.nodeName === 'SPAN'
						|| (event.target.hasChildNodes() && event.target.firstElementChild.nodeName === 'SPAN')
					) {
						event.preventDefault();

						menuItem.classList.toggle('open');
					}


				});
			});
		}

		// add mobile container to .site-navigation
		siteNavigation.appendChild(mobileMenuContainer);
		// move primary menu into mobile container
		mobileMenuContainer.appendChild(mobileMenuEl);
		// mobileMenuContainer.appendChild(primaryMenuEl);
	}
	
	/**
	 * Moves main menu back to desktop position.
	 */
    const desktopPrimaryMenu = () => {
        siteNavigation.appendChild(primaryMenuEl);
	}
	
	/**
	 * Moves utility to be after primary menu.
	 */
    const mobileUtility = () => {
        if (utilityEl !== null) {
			// move utility below main menu
            primaryMenuEl.after(utilityEl);
			// move primary above search form
			primaryMenuEl.before(searchForm);
			// set up for keyboard trap
			utilityLastChild.classList.add('menu-item__last');
        }
	}
	
	/**
	 * Moves utility menu back to desktop position and removes mobile menu container.
	 */
	const desktopUtility = () => {
        if (utilityEl !== null) {
			// remove class used for keyboard trap
			utilityLastChild.classList.remove('menu-item__last');
			// move search form back to utility section
			utilitySection.appendChild(searchForm);
			// move utility menu before search form
            searchForm.before(utilityEl);
            siteNavigation.classList.remove('toggled');
        }

        document.getElementById('mobile-menu-container').remove();
		// reset mobile menu active style/attr
		if ( toggleMobileBtn.getAttribute( 'aria-expanded' ) === 'true' ) {
			document.body.removeAttribute('style');
			toggleMobileBtn.setAttribute( 'aria-expanded', 'false' );
		}
	}
	
	/**
	 * Handles function calls in major breakpoints.
	 */
	const initEnquire = () => {

        enquire.register("screen and (max-width:1200px)", {
            match : function() {
                mobilePrimaryMenu();
                mobileUtility();
            },
            unmatch : function() {
                desktopPrimaryMenu();
                desktopUtility();
				resetTopLevelDropdowns('mouse');
            }
        });
	}

	/**
	 * Sticky Navigation
	 */
	let prevScrollY = window.scrollY;
	let bodyMargin = parseInt(window.getComputedStyle(document.body).marginTop);
	const stickyContainers = document.querySelectorAll('.is-sticky');

	// Show the sticky banner
	const showBanner = () => {
		if(!siteBanner.classList.contains('show')) {
			siteBanner.style.animationName = 'showStickyNav';
			siteBanner.classList.add('show');

			let height = siteBanner.offsetHeight - 2;
			setTimeout(() => {
				[].forEach.call(stickyContainers, container => {
					const stickyEl = container.querySelector('.stick-this');

					if(stickyEl.classList.contains('sticky')) {
						stickyEl.style.top = `${height}px`;
						height += stickyEl.offsetHeight;
					}
				});
			}, 50);

		}
	}

	// Hide the sticky banner
	const hideBanner = () => {
		if(siteBanner.classList.contains('show')) {
			siteBanner.style.animationName = 'hideStickyNav';
			siteBanner.classList.remove('show');

			[].forEach.call(stickyContainers, container => {
				const stickyEl = container.querySelector('.stick-this');

				stickyEl.style.top = null;
			});
		}
	}

	// Reset banner position to original position
	const resetBannerPosition = () => {
		siteBanner.style.animationName = null;

		if(siteBanner.classList.contains('show')) {
			siteBanner.classList.remove('show');
		}

		if(siteBanner.classList.contains('sticky')) {
			document.body.style.marginTop = bodyMargin.toString() + "px";
			siteBanner.classList.remove('sticky');
		}

		[].forEach.call(stickyContainers, container => {
			const stickyEl = container.querySelector('.stick-this');

			stickyEl.style.top = null;
		});
	}

	// Show the navigation if scrolling up
	window.addEventListener('scroll', event => {
		const scrollY = window.scrollY;

		// At top of viewport. Don't do anything.
		if(scrollY === 0) {
			resetBannerPosition();
			return false;
		}

		// Scrolling up
		if(prevScrollY > scrollY) {
			showBanner();
		}

		// Scrolling down
		if(prevScrollY <= scrollY) {
			// We don't want to do anything until the banner is off screen
			if(scrollY < siteBanner.offsetHeight) {
				resetBannerPosition();
				return false;
			}

			// Add the 'sticky' class to get banner in position
			if(!siteBanner.classList.contains('sticky')) {
				// Add body margin to compensate when site header is taken out of document flow
				bodyMargin = parseInt(window.getComputedStyle(document.body).marginTop);
				document.body.style.marginTop = (bodyMargin + siteBanner.offsetHeight).toString() + "px";

				// Add the sticky class to keep header at top of viewport
				siteBanner.classList.add('sticky');
			}

			hideBanner();
		}

		// Update scroll position for future comparison
		prevScrollY = window.scrollY;
	});

	document.addEventListener("DOMContentLoaded", () => {
        initEnquire();
		whatInput.registerOnChange(resetTopLevelDropdowns, 'intent');
    });
		
}() );
